import { render, staticRenderFns } from "./osAssoc.vue?vue&type=template&id=55c0bf8f&scoped=true"
import script from "./osAssoc.vue?vue&type=script&lang=js"
export * from "./osAssoc.vue?vue&type=script&lang=js"
import style0 from "./osAssoc.vue?vue&type=style&index=0&id=55c0bf8f&prod&scoped=true&lang=scss"
import style1 from "./osAssoc.vue?vue&type=style&index=1&id=55c0bf8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0bf8f",
  null
  
)

export default component.exports